/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 *
 * npm-core/src/constants.js
 *
 * NOTE: The constants defined in this file should ONLY be referred to key name
 *    and should ONLY be used in npm-core. Any use of these constants
 *    outside of npm-core is UNSUPPORTED.
 * Code that needs these constants should NEVER rely on the value of the constant
 *    since the values are subject to change across versions.
 *
 */
import ObjectTransformer from './utils/object-transformer';

export const publicConstants = {
  APP: {
    APP: 'app',
    ROOT: 'root',
    INFINITY_RUNTIME: 'Infinity',
    PXREQUESTOR: 'pxRequestor',
    PXUSERNAME: '.pxUserName',
    OPERATORID: 'OperatorID',
    USERNAME: 'pxRequestor.pxUserName',
    PXUSERIDENTIFIER: '.pxUserIdentifier',
    USERIDENTIFIER: 'pxRequestor.pxUserIdentifier',
    PYIMAGEINSKEY: '.pyImageInsKey',
    OPERATORID_IMG_INSKEY: 'OperatorID.pyImageInsKey',
    OPERATORID_LOCALE: 'OperatorID.pyUseLocale',
    APPLICATION_LABEL: 'Application.pyLabel',
    APPLICATION_RULE_NAME: 'Application.pyRuleName'
  },

  RESOURCE_TYPES: {
    ASSIGNMENT: 'ASSIGNMENT',
    CASE: 'CASE',
    DATA: 'DATA',
    PAGE: 'PAGE',
    OBJECT: 'OBJECT'
  },

  RESOURCE_STATUS: {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    OPEN_FLOW_ACTION: 'OPEN_FLOW_ACTION'
  },

  VIEW_NAMES: {
    PY_CASE_TAB: 'pyCaseTab',
    DATA_OBJECT_CREATE_VIEW: 'Create',
    DATA_OBJECT_EDIT_VIEW: 'pyEdit',
    PY_DATA_PREVIEW: 'pyDataPreview',
    PY_DETAILS: 'pyDetails',
    OBJECT_CREATE_VIEW: 'Create',
    SUBSCRIPT_CREATE_VIEW: 'SubscriptView'
  },
  CONTAINERS: {
    ROOT_CONTAINER: 'RootContainer',
    VIEW_CONTAINER: 'ViewContainer',
    FLOW_CONTAINER: 'FlowContainer',
    MODAL_VIEW_CONTAINER: 'ModalViewContainer',
    PREVIEW_VIEW_CONTAINER: 'PreviewViewContainer',
    HYBRID_VIEW_CONTAINER: 'HybridViewContainer'
  },

  WORK_BASKET: {
    MY_WORK_LIST: 'myWorkList',
    REPORTEE: 'reportee',
    WORK_QUEUE: 'workQueue',
    DATA_PAGES: {
      D__PY_GET_USER_WORK_LIST_BY_USER_ID: 'D_pyGetUserWorkListByUserId',
      D__WORK_BASKET: 'D_WorkBasket',
      D__PY_MY_WORK_LIST: 'D_pyMyWorkList'
    }
  },
  CONTEXT_TREE_NODE_TYPES: {
    VIEW: 'VIEW',
    FIELD: 'FIELD',
    DECLARATIVE_TARGET: 'DECLARATIVE_TARGET',
    WHEN: 'WHEN',
    CONTEXT: 'CONTEXT',
    PAGELIST: 'PAGELIST'
  },

  WORKLIST: 'worklist',
  WAIT: 'wait',
  TODO: 'todo',
  STANDARD_FLOW: 'Standard',
  CASE: 'CASE',
  ASSIGNMENT: 'ASSIGNMENT',
  FIX_BROKEN_ASSIGNMENTS: 'FixBrokenAssignments',
  PAGE: 'PAGE',
  PZINSKEY: '.pzInsKey',
  CREATE_DETAILS_VIEW_NAME: 'pzCreateDetails',
  PREVIEW_VIEW_NAME: 'pyCasePreview',
  CASESUMMARY_VIEW_NAME: 'pyCaseSummary',
  APPSHELL_ACTIVE_CASES: 'appshell-activecases',
  TRACE_ID: 'x-b3-traceid',
  LOAD_VIEW_STRING: 'View',
  PRIMARY: 'primary',
  DEFER_UPDATE_CASESUMMARY_VIEW: 'deferUpdateCaseSummaryView',

  NEXT_ASSIGNMENT_INFO_ID: 'nextAssignmentInfo.ID',
  WORKCLASS: 'Work-',
  DATA_INFO: {
    DATA_INFO: 'dataInfo',
    DATA_INFO_CONTENT: 'dataInfo.content'
  },
  OBJECT_INFO: {
    OBJECT_INFO: 'objectInfo',
    OBJECT_INFO_ID: 'objectInfo.ID',
    OBJECT_INFO_CONTENT: 'objectInfo.content',
    ACTIVE_ACTION_ID: 'objectInfo.activeActionID',
    OBJECT_INFO_CONTENT_CLASS_ID: 'objectInfo.content.classID'
  },
  CASE_INFO: {
    CASE_INFO: 'caseInfo',
    CASE_INFO_CONTENT: 'caseInfo.content',
    CASE_INFO_NAME: 'caseInfo.name',
    CASE_INFO_ID: 'caseInfo.ID',
    CASE_INFO_CLASSID: 'caseInfo.content.classID',
    CASE_INFO_CLASSNAME: 'caseInfo.className',
    CASE_TYPE_ID: 'caseInfo.caseTypeID',
    CASE_TYPE_NAME: 'caseInfo.caseTypeName',
    CASE_INFO_PZINSKEY: 'caseInfo.content.pzInsKey',
    CASE_INFO_ACTIONS: 'caseInfo.availableActions',
    VIEW_NAME: 'caseInfo.content.pyViewName',
    ACTION_BUTTONS: 'caseInfo.actionButtons',
    ACTIVE_ACTION_ID: 'caseInfo.activeActionID',
    ASSIGNMENT_LABEL: 'caseInfo.assignments[0].name',
    ASSIGNMENT_ID: 'caseInfo.assignments[0].ID',
    ASSIGNMENTS: 'caseInfo.assignments',
    INSTRUCTIONS: 'caseInfo.assignments[0].instructions',
    NAVIGATION: 'caseInfo.navigation',
    STAGES: 'caseInfo.stages',
    STAGEID: 'caseInfo.stageID',
    CASECLASS: 'caseInfo.caseClass',
    AVAILABLEACTIONS: 'caseInfo.availableActions',
    AVAILABLEPROCESSES: 'caseInfo.availableProcesses',
    D_CASE_ASSIGNMENTS_RESULTS: 'caseInfo.assignments',
    CHILD_ASSIGNMENTS: 'caseInfo.childCases',
    ASSIGNMENTACTION_ID: 'caseInfo.assignments[0].actions[0].ID',
    ISINCREATESTAGE: 'caseInfo.isInCreateStage',
    APPROVALFLAG: 'caseInfo.content.pyApprovalResult',
    DUPLICATECASEFLAG: 'caseInfo.content.pyDuplicateCaseActions',
    DUPLICATECASEID: 'caseInfo.content.pyDuplicateID',
    DUPLICATECASEINSKEY: 'caseInfo.content.pyDuplicateCaseReference.pzInsKey',
    HEADERS: 'caseInfo.headers',
    PARENTCASEINFO: 'caseInfo.parentCaseInfo',
    REMOTESYSTEMID: 'caseInfo.headers.RemoteSystemID',
    CASE_RELATED_CASE_TYPES: 'caseInfo.relatedCaseTypes',
    CASES: 'caseInfo.cases',
    GETNEXTWORK: 'caseInfo.confirmationLinks.getNextWork',
    ACTION_REFRESH_CONDITIONS: 'caseInfo.assignments[0].actions[0].refreshConditions',
    IS_LOCAL_ACTION: 'caseInfo.isLocalAction',
    BUSINESS_ID: 'caseInfo.businessID',
    IS_FIRST_ASSIGNMENT: 'caseInfo.isFirstAssignment',
    CASE_INFO_ATTACHMENTS: 'caseInfo.attachments'
  },

  ACTIONS: {
    ACTION_ID: 'actionID',
    ACTIONS: 'availableActions',
    DELETEAVIALACTIONS: 'deleteAvailActions',
    FLOWACTION: 'FlowAction',
    DATA_PAGES: {
      D_PY_ADDITIONAL_CASE_ACTIONS: 'D_pyAdditionalCaseActions'
    }
  },

  PROCESS: {
    FLOWPROBLEMS: 'FlowProblems'
  },

  PAGE_TYPES: {
    PAGE: 'page',
    LANDINGPAGE: 'landingpage',
    LISTPAGE: 'listpage'
  },

  LOCAL_ACTION_TYPE: {
    CASE_WIDE: 'case',
    EXPRESS: 'express',
    ASSIGNMENT: 'Assignment',
    LOCAL_ACTION: 'LocalAction'
  },

  LOCAL_ACTIONS: {
    TRANSFER_ASSIGNMENT: 'pyTransferAssignment'
  },

  CONTENT: 'content',
  MODAL: 'modal',
  STOPMERGEACTIONS: 'stopMergeActions',
  IS_CREATE_DATA_OBJECT: 'isCreateDataObject',
  SUMMARY_OF_ASSIGNMENT_LAST_SUBMIT_TIME: 'context_data.caseInfo.content.summary_of_assignment__.lastSubmitTime',
  SUMMARY_OF_ATTACHMENTS_LAST_REFRESH_TIME: 'context_data.caseInfo.content.summary_of_attachments__.lastRefreshTime',
  CONTEXT_DATA_ASSIGNMENTID: 'context_data.assignmentID',
  // Constants for Banner variant
  BANNER_VARIANT_SUCCESS: 'success',
  BANNER_VARIANT_WARNING: 'warning',
  BANNER_VARIANT_URGENT: 'urgent',
  BANNER_VARIANT_INFO: 'info',

  MESSAGES: {
    MESSAGES_TYPE_SUCCESS: 'success',
    MESSAGES_TYPE_INFO: 'info',
    MESSAGES_TYPE_ERROR: 'error' // Use this constants when you want to perform any action regarding error messages.
  },

  PUB_SUB_EVENTS: {
    EVENT_RENDER_APP: 'renderApp',
    EVENT_UNMOUNT_APP: 'unmountApp',
    EVENT_REAUTH: 'reAuth',
    EVENT_FULL_REAUTH: 'fullReAuth',
    EVENT_CUSTOM_REAUTH: 'customReAuth',
    EVENT_CANCEL: 'cancel',
    EVENT_MINIMIZE: 'minimize',
    EVENT_EXPRESS_LOCALACTION: 'expressLocalActionSubmit',
    EVENT_BULKACTION: 'bulkActionSubmit',
    EVENT_SHOW_CANCEL_ALERT: 'showCancelAlert',
    EVENT_SHOW_DELETE_ALERT: 'showDeleteAlert',
    EVENT_DASHBOARD_FILTER_CHANGE: 'dashboardFilterChange',
    EVENT_DASHBOARD_FILTER_CLEAR_ALL: 'dashboardFilterClearAll',
    EVENT_PROMOTED_FILTERS_CHANGE: 'promotedFiltersChange',
    EVENT_LOCALACTION_SUBMISSION: 'localActionSubmit',
    EVENT_LOGOFF: 'Logoff',
    EVENT_TRANSIENT_ITEMS: {
      UPDATE_PROMOTED_FILTERS: 'updatePromotedFilters'
    },
    UI_EVENTS: {
      INSPECTOR: 'inspector',
      INSPECTOR_SHOW_ALL: 'inspectorShowAll',
      SHOW_PAGE_INIT: 'showPageInit',
      SHOW_PAGE_DONE: 'showPageDone',
      SHOW_PAGE_STARTED: 'showPageStarted'
    },
    CASE_EVENTS: {
      CASE_ATTACHMENTS_UPDATED_FROM_CASEVIEW: 'caseAttachmentsUpdateFromCaseview',
      CASE_FOLLOWER_UPDATED_BY_OPERATOR_FROM_CASEVIEW: 'caseFollowerUpdateByOperatorFromCaseview',
      CASE_FOLLOWER_UPDATE_BY_OPERATOR_FROM_WIDGET: 'caseFollowerUpdateByOperatorFromWidget',
      CASE_CREATED: 'caseCreated',
      CREATE_STAGE_DONE: 'caseCreatedDone',
      CREATE_STAGE_CANCELLED: 'caseCancelled',
      CREATE_STAGE_SAVED: 'caseSaved',
      CREATE_STAGE_DELETED: 'caseDeleted',
      ASSIGNMENT_SUBMISSION: 'assignmentSubmission',
      END_OF_ASSIGNMENT_PROCESSING: 'endOfAssignmentProcessing',
      CLOSE_CONFIRM_VIEW: 'closeConfirmView',
      CASE_OPENED: 'caseOpened',
      CASE_VIEW_OPENED_AFTER_CREATE: 'caseViewOpenedAfterCreate',
      CASE_CLOSED: 'caseClosed',
      ASSIGNMENT_OPENED: 'assignmentOpened',
      CASE_PREVIEW: 'casePreview',
      CURRENT_ASSIGNMENT_UPDATED: 'currentAssignmentUpdated',
      CASE_LOCK_EVENT: 'caseLockEvent',
      GET_NEXT_WORK: 'getNextWork',
      SAVE_ASSIGNMENT_COMPLETE: 'saveAssignmentComplete'
    },
    WORK_EVENTS: {
      WORK_DELETED: 'workDeleted'
    },
    BOOTSTRAP_SHELL_EVENTS: {
      CONSTELLATION_LOADED: 'CONSTELLATION_LOADED'
    },
    CONTAINER_EVENTS: {
      CLOSE_CONTAINER_ITEM: 'CLOSE_CONTAINER_ITEM',
      CLOSE_MULTI_TYPE_PRIMARY_CONTAINER_ITEM: 'CLOSE_MULTI_TYPE_PRIMARY_CONTAINER_ITEM'
    },
    DISPLAY_CASE_CREATED_TOASTER: 'displayCaseCreatedToaster',
    DATA_EVENTS: {
      DATA_OBJECT_CREATED: 'dataObjectCreated',
      DATA_OBJECT_DELETED: 'dataObjectDeleted',
      DATA_OBJECT_UPDATED: 'dataObjectUpdated'
    },
    FETCH_SUCCESS: 'fetchSuccess',
    FETCH_FAILURE: 'fetchFailure',
    REVERSE_COEXISTENCE_EVENTS: {
      HANDLE_DISCARD: 'handleDiscard',
      CHECK_IS_FORM_DIRTY: 'checkIsFormDirty'
    },
    TIMEOUT_REMINDER: 'sessionAboutToTimeout',
    RESET_TIMER: 'resetInactivityTimer',
    PEGA_EMBED_CUSTOM: 'pegaEmbedCustom',
    SUGGESTION_PROCESSED: 'suggestion_processed',
    ERROR_ON_FINISH_ASSIGNMENT: 'errorOnFinishAssignment',
    URL_NAVIGATION: 'urlNavigation'
  },

  ERROR_TYPE: {
    CLIENT: 'client',
    SERVER: 'server'
  },

  CONTAINER_TYPE: {
    MULTIPLE: 'multiple',
    SINGLE: 'single',
    HYBRID: 'HybridViewContainer'
  },

  REMOTE_SYSTEM_ID: 'RemoteSystemID',

  LIST_SELECTION_MODE: {
    MULTI: 'multi',
    SINGLE: 'single',
    MULTI_ON_HOVER: 'multi_on_hover'
  },

  SUBMISSION_FAILURE_TYPE: {
    FORM_VALIDATION_ERROR: 'formValidationError'
  },

  USER_SETTINGS: {
    UTILITY_PANEL_USER_STATE_PATH: 'presentation.templates.CaseView.utilityPanelExpanded',
    SUMMARY_PANEL_USER_STATE_PATH: 'presentation.templates.CaseView.summaryPanelExpanded',
    ASSIGNMENT_COLLAPSED_STATE_PATH: 'presentation.templates.CaseView.assignmentWidgetCollapsed',
    CASE_VIEW_PATH: 'presentation.templates.CaseView'
  },

  PROMISE_VALUE: {
    RESOLVE: 'resolve',
    REJECT: 'reject'
  },

  APP_TYPE: {
    UIKIT: 'uikit',
    THEME_COSMOS: 'themecosmos'
  },
  PORTAL_TYPE: {
    WSS: 'wss'
  },
  VIEW_TYPE: {
    PY_EMBEDASSIGNMENT: 'pyEmbedAssignment',
    PY_DETAILS: 'pyDetails'
  },
  ACTION: 'action',
  CONTEXT_DATA_MODAL_VIEW: {
    CONTEXT_DATA_MODAL_VIEW: 'context_data.modalView',
    IS_MULTI_RECORD_DATA: 'context_data.modalView.isMultiRecordData',
    VIEW_NAME: 'context_data.modalView.viewName',
    PARENT_CONTEXT: 'context_data.modalView.parentContext',
    INTERESTPAGE: 'context_data.modalView.interestPage',
    EDIT_TYPE: 'context_data.modalView.editType',
    ACTION_ID: 'context_data.modalView.actionID'
  }
};

export default {
  CONTEXT: 'context',
  AJAXCONTAINER: 'primary',
  VIEW_CONTAINER: 'ViewContainer',
  APP_SHELL: 'AppShell',
  ROOT_CONTAINER: 'RootContainer',
  HYBRID: 'hybrid',
  HYBRID_VIEW_CONTAINER: 'HybridViewContainer',
  HYRBID_ROOT_CONTAINERNAME: 'hybridRootContainerName',
  MODAL_VIEW_CONTAINER: 'ModalViewContainer',
  FLOW_CONTAINER: 'FlowContainer',
  PREVIEW_VIEW_CONTAINER: 'PreviewViewContainer',
  OBJECT_PAGE: 'ObjectPage',
  CASE_CREATE_STAGE: 'CaseCreateStage',
  CASE_VIEW: 'CaseView',
  SELF_SERVICE_CASE_VIEW: 'SelfServiceCaseView',
  VIEW: 'view',
  CASE_PREVIEW: 'CasePreview',
  CASE_STAGES: 'Stages',
  CASEMESSAGES: 'caseMessages',
  SUGGESTION: 'suggestion',
  PREVIEW: 'preview',
  TERTIARY: 'tertiary',
  DEFAULT: 'default',
  ACPRIMARY: 'primary',
  ACTERTIARY: 'tertiary',
  PERFORM_MODE: 'perform',
  CASE_VIEW_MODE_PROP: '.caseViewMode',
  REVIEW_MODE: 'review',
  WORKAREA: 'workarea',
  ACPRIMARY_NAME: 'ACPRIMARY',
  ACTERTIARY_NAME: 'ACTERTIARY',
  THREADNAMESEPARATOR: '/',
  JOINCHARACTER: '_',
  FORWARD_SLASH_STRING: '/',
  UNDERSCORE_STRING: '_',
  WORK_ID: 'WORK_ID',
  EMPTY_STRING: '',
  PROPERTY_MESSAGES: 'propertyMessages__',
  CONTEXT_MESSAGES: 'contextMessages__',
  HTTP_MESSAGES: 'httpMessages__',
  PAGE_MESSAGES: 'pageMessages__',
  SUMMARY_OF_LISTS: 'summary_of_lists__',
  SUMMARY_OF_GROUPS: 'summary_of_groups__',
  SUMMARY_OF_MESSAGES: 'summary_of_messages__',
  SUMMARY_OF_FIELD_VALUES: 'summary_of_field_values__',
  SUMMARY_OF_WHEN_CONDITIONS: 'summary_of_when_conditions__',
  SUMMARY_OF_DYNAMIC_WHENS: 'summary_of_dynamic_whens__',
  SUMMARY_OF_EXPRESSIONS: 'summary_of_expressions__',
  SUMMARY_OF_ASSOCIATED_LISTS: 'summary_of_associated_lists__',
  CONTEXT_DATA: 'context_data',
  TABLE: (rowIndex: number) => `Table[${rowIndex}]`,
  HTTP: 'HTTP',
  PROPERTY: 'PROPERTY',
  PAGE_ERRORS: 'page_level_errors',
  CUSTOM_ERROR: 'custom error',
  NO_MESSAGES: 'No messages existing',
  PULSE_REFERENCE: 'pulse.messages',
  IS_LOADING: 'isLoading',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  DUPLICATE: 'Duplicate',
  IGNORE: 'Ignore',
  PARAGRAPH: 'PARAGRAPH',
  X_ORIGIN_CHANNEL: 'x-origin-channel',
  AUTHORING_PREVIEW_CONTAINER: 'root/authoring-preview',
  EMBED: 'EMBED',
  // Constants from server response
  ERROR_FIELD_IN_PAGE: 'erroneousInputOutputFieldInPage',
  ERROR_IN_PAGE_IDENTIFIER: 'erroneousInputOutputIdentifier',
  ON_REFRESH_START: 'onRefreshStart',
  ON_REFRESH_ERROR: 'onRefreshError',
  ON_REFRESH_COMPLETE: 'onRefreshComplete',

  UI_RESOURCES: 'uiResources',
  UI_RESOURCES_CONTEXT_DATA: 'uiResources.context_data',
  ACTION_BUTTONS: 'uiResources.actionButtons',
  RESOURCES: 'uiResources.resources',
  ROOT: 'uiResources.root',
  CASE_INFO_IS_LOCAL_ACTION: 'caseInfo.isLocalAction',
  OBJECT_INFO_IS_LOCAL_ACTION: 'objectInfo.isObjectWideAction',
  DATA: 'data',
  OPTIONS: 'options',
  VIEWS: 'uiResources.resources.views',
  NAVIGATIONS: 'uiResources.resources.navigations',
  COMPONENTS: 'uiResources.components',
  UI_RESOURCES_ROOT_CONTEXT: 'uiResources.root.config.context',
  LOCALE_REFERENCES: 'uiResources.localeReferences',
  STATIC_SERVER_URL: 'staticServer',
  APPLICATION_DATA: 'data.Application',
  REFERENCED_USERS: 'referencedUsers',
  CASE_INFO_REFRESH_CONDITIONS: 'caseInfo.refreshConditions',

  // Constants for FieldLevelError messages
  FIELD_LEVEL_SUCCESS: 'success',
  FIELD_LEVEL_WARNING: 'warning',
  FIELD_LEVEL_ERROR: 'error',
  HASH_DELIMITER: '~^|^~',
  NULL_STRING: 'null',
  DATA_PAGE: 'DataPage',
  DECISION: 'Decision',
  RULE_REFERENCE: 'RuleReference',
  GET_PAGE_DATA: 'getPageData',
  PROPERTY_ANNOTATION: '@P',
  FIELD_LABEL_ANNOTATION: '@FL',
  ATTACHMENT_ANNOTATION: '@ATTACHMENT',
  PARAGRAPH_ANNOTATION: '@PARAGRAPH',
  ASSOCIATED_PROPERTY_ANNOTATION: '@ASSOCIATED',
  CLASS_ANNOTATION: '@CLASS',
  ASSOCIATED: 'associated',
  CLASS_ID: '.classID',
  CLASSID: 'classID',
  READONLY: 'readonly',
  SHARED: 'shared',
  RELOAD_IF_OLDER_THAN: 'reloadIfOlderThan',
  RELOAD_ONCE_PER_INTERACTION: 'reloadOncePerInteraction',
  PY_DETAILS: 'pyDetails',
  PY_CONFIRM: 'pyConfirm',
  LIST_ACTIONS: {
    ADD: 'ADD',
    INSERT: 'INSERT',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DELETE_ALL: 'DELETE ALL',
    MOVE: 'MOVE',
    SELECT: 'SELECT',
    DESELECT: 'DESELECT',
    REPLACE: 'REPLACE',
    DELETEPAGE: 'DELETEPAGE'
  },
  LIST_ACTIONS_TYPE: {
    SELECT_DESELECT: 'SELECT_DESELECT',
    DESELECT_ALL: 'DESELECT_ALL'
  },
  ENV_INFO_KEYS: {
    APPLICATION_NAME: 'APPLICATION_NAME',
    APPLICATION_DESC: 'APPLICATION_DESC',
    ACCESS_GROUP: 'ACCESS_GROUP',
    USER_NAME: 'USER_NAME',
    USER_ID: 'USER_ID',
    USER_IMAGE: 'USER_IMAGE',
    LOCALE: 'LOCALE',
    TIMEZONE: 'TIMEZONE',
    WORK_GROUP: 'WORK_GROUP'
  },
  ID: 'ID',
  SCALARLIST: 'ScalarList',
  COREHEADERS: 'coreHeaders',
  SKIPCOREHEADERS: 'skipCoreHeaders',
  COREHEADER_APP_DEBUG_ID: 'X-Pega-App-Debug-ID',
  COREHEADER_APP_DEBUG_LEVELS: 'X-Pega-App-Debug-Levels',
  EMBEDDED_DATA_MODAL: {
    SHOW_ROW: 'showRow',
    SUBMIT_ROW: 'submitRow',
    EDIT_TYPE: 'editType',
    ACTION_NAME: 'actionName',
    REFRESH_CONDITIONS: 'caseInfo.refreshConditions'
  },
  LOCALIZATION_V2: 2,
  DATA_CLASS_NOT_FOUND: 'Data object class not found',
  PRIORITY: {
    CRITICAL: 100,
    HIGH: 500,
    MEDIUM: 1000,
    LOW: 2000,
    TRIVIAL: 3000
  },
  ...publicConstants,
  getProperty: (key: string) => {
    return ObjectTransformer.map(key);
  }
};
